export const urlRegex =
    /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»""'']))/i;

export const tagRegex = /(@\w+)/i;

export const lineBreakRegex = /([\r\n])/;

export const urlOrTagRegex =
    /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»""'']))|(@\w+)|([\r\n])/i;

export const fixUrl = (url: string) => {
    const protocolRegex = /^([a-z]+:\/\/)/i; // Case-insensitive protocol check
    if (!protocolRegex.test(url)) {
        return `https://${url}`; // Default to HTTPS if no protocol provided
    }
    return url;
};

export const escapeRegExp = (string: string): string => {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};
